import { render } from "./MarketPricesList.vue?vue&type=template&id=71db5f48&scoped=true"
import script from "./MarketPricesList.vue?vue&type=script&lang=js"
export * from "./MarketPricesList.vue?vue&type=script&lang=js"

import "./MarketPricesList.vue?vue&type=style&index=0&id=71db5f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.106.2_@swc+core@1.3.96_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71db5f48"]])

export default __exports__